import { DataPermissionTypeDataEnum } from '@ysura/common';

import { createEnumMapperFunction } from '@/services/graphql/mappers/utils';
import { DataPermissionType } from '@/services/graphql/types';

export const mapperToDataPermissionTypeDataEnum = createEnumMapperFunction(
  DataPermissionType,
  DataPermissionTypeDataEnum
);
